import React, { useEffect, useState } from "react";
import Layout from "../../layouts";
import apiService from "../../services/apiService";
import { toast } from "react-toastify";

export default function AndroidMobileVersioning() {
  const [showModal, setShowModal] = useState(true); // default open
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [id, setId] = useState<number | null>(null);
  const [minimumVersion, setMinimumVersion] = useState("");
  const [forceUpdateVersion, setForceUpdateVersion] = useState("");

  // 🔹 Fetch current android versioning
  const fetchAndroidVersion = async () => {
  try {
    setLoading(true);
    const res: any = await apiService.get(
      "/version/get-android-app-version"
    );

    console.log("API response for android version info:", res);
    const item = res?.data?.[0]; // ✅ array → first item

    console.log("Fetched Android version info:", item);
    if (item) {
      setId(item.id ?? null);
      setMinimumVersion((item.minimumVersion ?? "").trim());
      setForceUpdateVersion((item.forceUpdateVersion ?? "").trim());
    }
  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch android app version");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchAndroidVersion();
  }, []);

  // 🔹 Update android versioning
  const handleUpdate = async () => {
    const minVersion = minimumVersion.trim();
    const forceVersion = forceUpdateVersion.trim();

    if (!minVersion || !forceVersion) {
      return toast.error("Both fields are required");
    }

    const payload = {
      id,
      minimumVersion: minVersion,
      forceUpdateVersion: forceVersion,
    };

    try {
      setSubmitting(true);
     const res:any =  await apiService.put("/version/update-android-app-version", payload);
      toast.success(res?.data ||"Android app version updated successfully1");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update android app version");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout pageTitle="Mobile Versioning">
      {showModal && (
        <div className="fixed inset-y-0 left-64 right-0 bg-black/40 flex items-center justify-center z-40">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-semibold mb-4">Mobile Versioning</h2>

            {loading ? (
              <p className="text-sm text-gray-500">Loading version info…</p>
            ) : (
              <>
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1">
                    Minimum Supported Version
                  </label>
                  <input
                    type="text"
                    value={minimumVersion}
                    onChange={(e) => setMinimumVersion(e.target.value)}
                    placeholder="e.g. 1.2.2"
                    className="border rounded-lg w-full px-3 py-2"
                  />
                </div>

                <div className="mb-6">
                  <label className="block text-sm font-medium mb-1">
                    Force Update Version
                  </label>
                  <input
                    type="text"
                    value={forceUpdateVersion}
                    onChange={(e) => setForceUpdateVersion(e.target.value)}
                    placeholder="e.g. 1.2.2"
                    className="border rounded-lg w-full px-3 py-2"
                  />
                </div>

                <div className="flex justify-end gap-3">
                  {/* <button
                    onClick={() => setShowModal(false)}
                    className="px-4 py-2 border rounded-lg hover:bg-gray-100"
                  >
                    Close
                  </button> */}
                  <button
                    onClick={handleUpdate}
                    disabled={submitting}
                    className={`px-4 py-2 rounded-lg text-white ${
                      submitting
                        ? "bg-indigo-300 cursor-not-allowed"
                        : "bg-indigo-600 hover:bg-indigo-700"
                    }`}
                  >
                    {submitting ? "Updating…" : "Update Version"}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </Layout>
  );
}
